import { AbstractRealtimeComponent } from '../../abstract-realtime-component';
export default class PaymentPatientRealtimeComponent extends AbstractRealtimeComponent {
    /* @ngInject */
    constructor(paymentPopup, notificationFactory, // still in js
    patientRealtimeActions) {
        super();
        this.paymentPopup = paymentPopup;
        this.notificationFactory = notificationFactory;
        this.patientRealtimeActions = patientRealtimeActions;
    }
    create() {
        return this;
    }
    reset() {
        this.paymentPopup.hide();
    }
    onLeave(person) {
        if (!this.target.isEqualTo(person)) {
            return;
        }
        this.reset();
    }
    onMessage(message, person) {
        switch (message.action) {
            case 'paymentRequest': {
                this.onPaymentRequest(message, person);
                break;
            }
            case 'close': {
                this.paymentPopup.hide();
                this.notificationFactory.showCommon('warning', 'payment-ended');
                break;
            }
            default:
                throw new Error(`Unhanded patient message case: ${message.action}`);
        }
    }
    onPaymentRequest(message, person) {
        if (this.target && !this.target.isEqualTo(person)) {
            return;
        }
        this.target = person;
        this.paymentPopup.hide();
        this.paymentPopup.open({
            target: this.target,
            amount: message.content.amount,
            clientSecret: message.content.clientSecret,
            connectedStripePublishable: message.content.connectedStripePublishable,
            currency: message.content.currency,
            onCancel: (notify) => {
                this.paymentPopup.hide();
                if (notify) {
                    this.patientRealtimeActions.sendToTarget(this.target, {
                        componentName: 'payment',
                        action: 'close',
                    });
                }
            },
            onProcessing: () => {
                const pnPaymentPaidMessage = {
                    componentName: 'payment',
                    action: 'paymentProcessing',
                };
                this.patientRealtimeActions.sendToTarget(this.target, pnPaymentPaidMessage);
            },
            onError: () => {
                const errorMessage = {
                    componentName: 'payment',
                    action: 'paymentError',
                };
                this.patientRealtimeActions.sendToTarget(this.target, errorMessage);
            },
            onSuccess: () => {
                const pnPaymentPaidMessage = {
                    componentName: 'payment',
                    action: 'paymentSuccess',
                };
                this.patientRealtimeActions.sendToTarget(this.target, pnPaymentPaidMessage);
            },
        });
    }
}
